import { Button, Typography } from '@mui/material';
import React from 'react';
import { AttachmentInput } from 'sr-types/lib/production/v1/graphql';
import I18n from '../i18n/I18n';
import { H, V } from '../Layout';
import AttachmentsRenderer from './AttachmentsRenderer';
import FormWidget from '../form/FormWidget';
import LoadingButton from '@mui/lab/LoadingButton';

export default ({
    saveFiles,
    onDelete,
    onTagChange,
    defaultMandatoryTags,
    saveAttachment,
    isSaveDisabled,
    isSaving,
    onCancelEdit
}: {
    saveFiles: AttachmentInput[];
    onDelete: (file: AttachmentInput, index: number) => void;
    onTagChange: (name: string, value: string[], index: number) => void;
    defaultMandatoryTags?: Array<string>;
    saveAttachment: () => void;
    isSaveDisabled?: boolean;
    isSaving?: boolean;
    onCancelEdit: () => void;
}) => {
    return (
        <>
            {saveFiles.length != 0 && (
                <V gap={1} sx={{ overflow: 'auto', p: 2 }}>
                    <Typography fontSize={'medium'} sx={{ flexGrow: 2 }}>
                        <I18n token={'attachments.preview'} />
                    </Typography>
                    {saveFiles.map((file, index) => (
                        <V key={index} gap={2}>
                            <AttachmentsRenderer
                                key={index}
                                file={file}
                                isPreview={true}
                                onDelete={() => onDelete(file, index)}
                            />
                            <FormWidget
                                component="MetadataAutocomplete"
                                onChange={(name, value) => onTagChange(name, value, index)}
                                value={file.tagSet}
                                metadataName="DocumentTag"
                                identifier="termset"
                                multiple
                                allowCreate
                                name="tag"
                                label={<I18n token="common.label.tag" />}
                                fixedOptions={defaultMandatoryTags}
                            />
                        </V>
                    ))}
                    <H sx={{ justifyContent: 'flex-end' }}>
                        <Button variant="text" sx={{ mr: 2 }} onClick={onCancelEdit}>
                            <I18n token="dialog.cancel" />
                        </Button>
                        <LoadingButton
                            variant="contained"
                            onClick={saveAttachment}
                            disabled={isSaveDisabled}
                            loading={isSaving}
                            onMouseDown={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <I18n token="form.button.save" />
                        </LoadingButton>
                    </H>
                </V>
            )}
        </>
    );
};
